const PHONE_WITHOUT_COUNTRY_CODE_REGEX = new RegExp("^[6789]{1}[0-9]{9}$");

export const isValidString = (value: string | null | undefined): boolean =>
    !(value === null || value === "null" || value === "undefined" || value === undefined || value === "");

export const isValidPhoneNumber = (phoneNumber: string) => PHONE_WITHOUT_COUNTRY_CODE_REGEX.test(phoneNumber);
